import {useEffect, useState} from 'react'
import {useSearchParams, useNavigate} from 'react-router-dom'

import PaymentWidget from 'widget/PaymentWidget'

import {eventAmount} from 'shared/constant/amountList'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import getEventIdxFromUrl from 'shared/lib/getEventIdxFromUrl'

const TryoutEventPayment = () => {
	const navigate = useNavigate()

	const [searchParams] = useSearchParams()
	const eventName = searchParams.get('eventName')
	const branchName = searchParams.get('branchName')

	const eventIdx = getEventIdxFromUrl()

	const [isError, setIsError] = useState(true)

	const [, setAlert] = useAlertModalAtom()

	// // query 예외처리
	useEffect(() => {
		if (!eventName || eventName === '') {
			setAlert('대회 이름이 올바르지 않습니다.')
			navigate('/event')
		} else if (!eventIdx || eventIdx == '') {
			setAlert('대회 idx가 올바르지 않습니다.')
			navigate('/event')
		} else {
			setIsError(false)
		}
	}, [])

	const props = {
		amount: eventAmount,
		orderName: `${eventName} 참가권${branchName ? ` - ${branchName}` : ''}`,
		callbackUrl: `event/done?eventIdx=${eventIdx}`,
	}

	return !isError && <PaymentWidget {...props} />
}

export default TryoutEventPayment
